/**
 * 検索結果
 */

import $ from 'jquery';
import {
	TweenMax
} from 'gsap';
import {
	mq,
	lang
} from '../module/Global';

const tm = TweenMax;

class Result {
	constructor() {
		this.$main = $('.result-main');

		this.$cc_list = $('.cc-list');
		this.$cc_item = $('.cc-list__item');
		this.$cc_check_btn = $('.cc-item-check');
		this.$cc_result_btns = $('.result-btns--cc');
		this.$cc_clear_btn = this.$cc_result_btns.find('.result-btn__link--clear');
		this.$cc_only_btn = this.$cc_result_btns.find('.result-btn__link--only');
		this.is_cc_only = false;

		this.$pm_contents = $('.pm-contents');
		this.$pm_item = $('.pm-item');
		this.$pm_product = $('.pm-item__product');
		this.$pm_check_btn = $('.pm-item-check');
		this.$pm_list = $('.pm-list');
		this.$pm_list_item = $('.pm-list__item');
		this.$pm_result_btns = $('.result-btns--pm');
		this.$pm_clear_btn = this.$pm_result_btns.find('.result-btn__link--clear');
		this.$pm_only_btn = this.$pm_result_btns.find('.result-btn__link--only');

		this.is_pm_only = false;
		this.$rating_btn = $('.pm-item__product__rating-btn');
		// this.$rating_btn_text = '';

		this.$download_btn = $('.result-btn__link--download');
		
		this.$toast = $('.app-toast');
		this.$btnArrow = $('.btn-result__arrow');

		this.toast_timer = null;
		this.rootTypeId = 'abc';



		this.initChangeBtn();
		this.set = {
			cc: new Set(),
			pm: new Set(),
			alias: new Set()
		};
		this.param = {
			chemical_id: [],
			product_id: [],
			alias_no: []
		};

		this.url_param = this.getUrlVars();

		this.getData();
		
	}

	/**
	 *  試験切り替えボタンにリンクをセットする
	 */

	initChangeBtn(){
		const paramList = [
			{id:'astmf739',text:'ASTM <br class="pc-only">F739'},
			{id:'en374',text:'EN374'},
		];
		const $btn = $('.select-block__ul').find('a');
		const strType = 'type';
		let path = location.pathname;
		let search = location.search;
		let url = '';
		let typeId = '';
		if(search.match(/&type=/)){
			search = location.search.split('&type=')[0];
			typeId = location.search.split('&type=')[1];
		}
		if(typeId === ''){
			typeId = paramList[0].id;
		}
		if(search.slice(-1) === '&'){
			search = search.slice(0,-1);
		}
		url = path+search+'&'+strType+'=';
		let setHtml = `<ul class="select-block__ul">`;
		for (var i = 0; i < paramList.length; i++) {
			
			let isLink = true;
			// console.log(paramList[i].id+'/'+typeId);
			if(paramList[i].id === typeId){
				isLink = false;
			}
			// console.log(isLink);
			if(!isLink){
				setHtml +=`<li class="select-block__li active">`;
				setHtml +=`<span class="select-block__link" data-cat="${paramList[i].id}">${paramList[i].text}</span>`;
			}else{
				setHtml +=`<li class="select-block__li">`;
				setHtml +=`<a href="${url+paramList[i].id}" class="select-block__link" data-cat="${paramList[i].id}">${paramList[i].text}</a>`;
			}
			setHtml +='</li>';
		}
		setHtml += `</ul>`;
		this.rootTypeId = typeId;

		$('.select-block').prepend(setHtml);
	}


	/**
	 *  GETパラメータを配列にして返す
	 */
	getUrlVars() {
		let vars = {};
		const param = location.search.substring(1).split('&');

		for (let i = 0; i < param.length; i++) {
			const query = param[i].split('=');
			const key = query[0];
			const val = query[1];

			if (key.indexOf('[]') > -1) {
				if (!vars[key]) vars[key] = [];
				vars[key].push(val);
			} else {
				vars[key] = val;
			}
		}
		return vars;
	}

	/**
	 * jsonデータ取得
	 */
	getData() {
		let url = './load_result.html';
		const query = $('input[name="search_query"]').val();
		let option = {
			method: 'POST',
			credentials: 'include'
		};

		if (
			location.host === 'chemrest.localhost' ||
			location.host === 'localhost' ||
			location.hash.indexOf('mode=develop') > -1
		) {
			url = '/_develop/result.json';
			option = {
				method: 'GET'
			};
		}

		url += `?${query}`;

		fetch(url, option)
			.then(res => {
				return res.json();
			})
			.then(this.loadData.bind(this));
	}

	/**
	 * json読み込み完了
	 */
	loadData(json) {
		this.data = json.data;
		this.domCreate(this.data);
	}

	/**
	 * イベント登録
	 */
	addListeners() {
		$(window).on({
			layoutChange: $.proxy(this.layoutChange, this),
			scroll: $.proxy(this.onScroll, this)
		});
		this.$main.on('scroll', $.proxy(this.mainScroll, this));

		this.$cc_check_btn.on('click', $.proxy(this.ccItemCheck, this));
		this.$cc_clear_btn.on('click', $.proxy(this.ccAllClear, this));
		this.$cc_only_btn.on('click', $.proxy(this.ccToggleOnly, this));

		this.$pm_check_btn.on('click', $.proxy(this.pmItemCheck, this));
		this.$pm_clear_btn.on('click', $.proxy(this.pmAllClear, this));
		this.$pm_only_btn.on('click', $.proxy(this.pmToggleOnly, this));
		this.$rating_btn.on('click', $.proxy(this.toggleRating, this));

		this.$download_btn.on('click', $.proxy(this.downloadClick, this));
		this.$downloadFull_btn.on('click', $.proxy(this.downloadClickFull, this));

		this.$toast.on('click', $.proxy(this.toastHide, this));

		this.$btnArrow.on('click', $.proxy(this.pmArrow, this));
		$(window).on('resize', $.proxy(this.onResultResize, this));
	}

	downloadClickFull(e){
		// $(window).trigger('MODAL_OPEN');
		const $_this = $(e.currentTarget);
		const form = document.createElement('form');
		const login = $('input[name="user_auth_cond"]').val();
		$('.sign-modal').hide();
		if (parseInt(login) !== 1) {
			e.preventDefault();
		}else{
			const url = $_this.attr('href');
			// console.log(url);
			window.open(url,'_blank');
		}
		
	}

	/**
	 * レイアウト切り替え
	 * @param {*} e
	 */
	layoutChange(e) {
		this.layout = e.originalEvent.detail.layout;
		this.heightMatch();
	}

	/**
	 * スクロール処理
	 */
	onScroll() {
		const sp_download = $('.sp-download-btn');
		const top = $(window).scrollTop();
		const scroll_bottom = top + $(window).height();
		const footer = $('.global-footer');
		const footer_top = footer.offset().top;
		const pm_top = this.$pm_contents.offset().top;
		const pm_scroll = top - pm_top;
		if (mq.getLayout() === 'sp') {
			if (top >= pm_top) {
				tm.to(this.$pm_product, 0.1, {
					y: pm_scroll
				});
			} else {
				tm.set(this.$pm_product, {
					y: 0
				});
			}
		} else {
			tm.set(this.$pm_product, {
				y: 0
			});
		}

		if (scroll_bottom >= footer_top) {
			sp_download.addClass('sp-download-btn--sp-bottom');
		} else {
			sp_download.removeClass('sp-download-btn--sp-bottom');
		}
	}

	/**
	 * スマホ 結果のスクロール処理
	 */
	mainScroll() {
		const left = this.$main.scrollLeft();
		const layout = mq.getLayout();
		const $cc_all = $('.cc-all');
		if (layout === 'sp') {
			if (left >= 72) {
				$cc_all.addClass('cc-all--fix');
				tm.to($cc_all, 0.15, {
					x: left
				});
			} else {
				$cc_all.removeClass('cc-all--fix');
				tm.set($cc_all, {
					x: 0
				});
			}
		} else {
			$cc_all.removeClass('cc-all--fix');
			tm.set($cc_all, {
				x: 0
			});
		}
	}

	/**
	 * item_dataからDOMを作成追加
	 */
	domCreate(item_data) {
		// CCアイテム作成
		let cc_items = '';

		let pm_bdt = '<p class="pm-ttl-txt pm-ttl-txt--bdt">BDT';

		if ($('body').hasClass('lang-ja')) {
			pm_bdt = '<p class="pm-ttl-txt pm-ttl-txt--bdt em2">BDT<br>(破過検出時間)'
		}

		for (let i = 0, l = item_data.chemical.length; i < l; i++) {
			let d = item_data.chemical[i];
			let concentration = item_data.chemical[i].concentration;

			if (concentration !== '') {
				d.chemical_name += ` | ${concentration}%`;
			}

			cc_items += `
				<li class="cc-list__item" data-id="${d.chemical_id}" data-alias="${d.alias_no}" data-index="${i}">
					<p class="cc-item-check"><i class="cc-item-check__icon"></i></p>
					<p class="cc-item-txt cc-item-txt--name">${d.chemical_name}</p>
					<p class="cc-item-txt cc-item-txt--num">${d.cas_number}</p>
				</li>
			`;
		}

		// PMアイテム作成
		let pm_items = '';
		for (let i = 0, l = item_data.product.length; i < l; i++) {
			let d = item_data.product[i];
			let rating_btn = 'pm-item__product__rating-btn pm-item__product__rating-btn--no';
			let fullpdf_link = '';
			let product_link = '';
			let test_results = '';
			let degradation = 'DEGRADATION RATING';
			let rating_btn_text = '';
			let link_title = 'Product<br>URL';
			let rating_title = 'Degradation';
			let fullpdf_title = 'Download <br>all data';


			
			if (lang === 'it') {
				degradation = 'INDICE DI DEGRADO';
				link_title = 'URL del <br>prodotto';
				rating_title = 'INDICE DI<br>DEGRADO';
				fullpdf_title = 'Scarica tutti <br>i dati';

			} else if (lang === 'fr') {
				degradation = 'INDICE DE DEGRADATION';
				link_title = 'URL du<br>produit';
				rating_title = 'INDICE DE<br>DEGRADATION';
				fullpdf_title = 'Télécharger <br>toutes <br>les données';
			} else if (lang === 'es') {
				degradation = 'ÍNDICE DE DEGRADACIÓN';
				link_title = 'URL del<br>producto';
				rating_title = 'ÍNDICE DE<br>DEGRADACIÓN';
				fullpdf_title = 'Descargar <br>todos <br>los datos';
			} else if (lang === 'nl') {
				degradation = 'DEGRADATIESCORE';
				link_title = 'Product<br>url';
				rating_title = 'DEGRADATIE<br>SCORE';
				fullpdf_title = 'Download <br>alle gegevens';
			} else if (lang === 'de') {
				degradation = 'DEGRADATIONSBEWERTUNG';
				link_title = 'Produkt-<br>URL';
				rating_title = 'DEGRADATION<br>SBEWERTUNG';
				fullpdf_title = 'Alle Daten <br>herunterladen';
			} else if (lang === 'ja') {
				degradation = '耐劣化性等級';
				link_title = '製品URL';
				rating_title = '耐劣化性等級';
				fullpdf_title = 'すべての<br>データの<br>ダウンロード';
			}
			// console.log(fullpdf_title);
			if (!d.full_pdf || d.full_pdf === '') {
				fullpdf_link = `<a href="javascript:void(0)" class="pm-item__product__link pm-item__product__link--no"></a>`;
			}else{
				fullpdf_link = `<a href="${d.full_pdf}" target="_blank" class="pm-item__product__fullpdf"><span class="pm-item__product__link--text">${fullpdf_title}</span></a>`;
			}

			if (!d.url || d.url === '') {
				product_link = `<a href="javascript:void(0)" class="pm-item__product__link pm-item__product__link--no"></a>`;
			} else {
				product_link = `<a href="${d.url}" target="_blank" class="pm-item__product__link"><span class="pm-item__product__link--text">${link_title}</span></a>`;
			}

			for (let j = 0, k = d.test_results.length; j < k; j++) {
				let t = d.test_results[j];
				let rating = t.degradations;
				let int = parseInt(t.bdt_int_text);
				let int_txt = '';
				let ttl = parseInt(t.bdt_ttl_text);
				let ttl_txt = '';
				// console.log(t);
				if (!rating || rating.length <= 0) rating = [{
					val: ''
				}, {
					val: ''
				}, {
					val: ''
				}, {
					val: ''
				}];
				if (
					rating[0].val === 'NT' &&
					rating[1].val === 'NT' &&
					rating[2].val === 'NT' &&
					rating[3].val === 'NT'
				) {
					t.has_degradation = false;
				}
				if (t.has_degradation) {
					rating_btn = 'pm-item__product__rating-btn'
					rating_btn_text = `<span class="pm-item__product__rating-btn--text">${rating_title}</span>`;
				};

				if (isNaN(int)) {
					int = t.bdt_int_text;
					int_txt = t.bdt_int_text;
				} else {
					if (int < 1) {
						int = '1';
						int_txt = '&lt;1';
					} else if (int >= 1 && int <= 5) {
						int = '1-5';
						int_txt = '1~5';
					} else if (int >= 6 && int <= 10) {
						int = '6-10';
						int_txt = '6~10';
					} else if (int >= 480) {
						// int_txt = `${t.bdt_int_symbol_pre}${t.bdt_int_symbol_suf}${t.bdt_int_text}`;
						int = '480';
						int_txt = '&gt;480';
					} else if (int >= 240) {
						// int_txt = `${t.bdt_int_symbol_pre}${t.bdt_int_symbol_suf}${t.bdt_int_text}`;
						int = '240';
						int_txt = '&gt;240';
					} else if (int >= 120) {
						int = '120';
						int_txt = '&gt;120';
					} else if (int >= 60) {
						int = '60';
						int_txt = '&gt;60';
					} else if (int >= 30) {
						int = '30';
						int_txt = '&gt;30';
					} else if (int >= 10) {
						int = '10';
						int_txt = '&gt;10';
					}
				}

				if (isNaN(ttl)) {
					ttl = t.bdt_ttl_text;
					ttl_txt = t.bdt_ttl_text;
				} else {
					if (ttl < 1) {
						ttl = '1';
						ttl_txt = '&lt;1';
					} else if (ttl >= 1 && ttl <= 5) {
						ttl = '1-5';
						ttl_txt = '1~5';
					} else if (ttl >= 6 && ttl <= 10) {
						ttl = '6-10';
						ttl_txt = '6~10';
					} else if (ttl >= 480) {
						// ttl_txt = `${t.bdt_ttl_symbol_pre}${t.bdt_ttl_symbol_suf}${t.bdt_ttl_text}`;
						ttl = '480';
						ttl_txt = '&gt;480';
					} else if (ttl >= 240) {
						ttl = '240';
						ttl_txt = '&gt;240';
					} else if (ttl >= 120) {
						ttl = '120';
						ttl_txt = '&gt;120';
					} else if (ttl >= 60) {
						ttl = '60';
						ttl_txt = '&gt;60';
					} else if (ttl >= 30) {
						ttl = '30';
						ttl_txt = '&gt;30';
					} else if (ttl >= 10) {
						ttl = '10';
						ttl_txt = '&gt;10';
					}
				}

				test_results += `
					<li class="pm-list__item">
						<ul class="pm-c-list ac-rating">
							<li class="pm-c-list__item pm-c-list__item--${rating[0].val}">${rating[0].val}</li>
							<li class="pm-c-list__item pm-c-list__item--${rating[1].val}">${rating[1].val}</li>
							<li class="pm-c-list__item pm-c-list__item--${rating[2].val}">${rating[2].val}</li>
							<li class="pm-c-list__item pm-c-list__item--${rating[3].val}">${rating[3].val}</li>
						</ul>
						<ul class="pm-c-list pm-c-list--bdt">
							<li class="pm-c-list__item pm-c-list__item--${ttl}">${ttl_txt}</li>
							<li class="pm-c-list__item pm-c-list__item--${int}">${int_txt}</li>
						</ul>
					</li>
				`;
			}

			pm_items += `
				<div class="pm-item" data-id="${d.product_id}" data-code="${d.product_code}" data-index="${i}">
					<div class="pm-item__product">
						<div class="pm-item-check"></div>
						<div class="pm-item__product__detail">
							<img src="${d.product_image}" alt="" class="product-thumb">
							<div class="product-txt">
								<p class="product-txt__ttl">${d.product_name}<br><span class="txt-num">${d.product_code}</span></p>
							</div>
						</div>
						${fullpdf_link}
						${product_link}
						<div class="${rating_btn}">${rating_btn_text}</div>
					</div>
					<div class="pm-all">
						<div class="pm-all__ttl">
							<p class="pm-ttl-txt ac-rating"><i class="pm-ttl-txt__icon"></i>${degradation}</p>
							${pm_bdt}</p>
						</div>
						<div class="pm-all__sttl">
							<ul class="pm-sttl-list ac-rating">
								<li class="pm-sttl-list__item">5m</li>
								<li class="pm-sttl-list__item">30m</li>
								<li class="pm-sttl-list__item">60m</li>
								<li class="pm-sttl-list__item">240m</li>
							</ul>
							<ul class="pm-sttl-list pm-sttl-list--bdt">
								<li class="pm-sttl-list__item">TTL</li>
								<li class="pm-sttl-list__item">INT</li>
							</ul>
						</div>
						<ul class="pm-list">
							${test_results}
						</ul>
					</div>
				</div>
			`;
		}

		this.$cc_list[0].insertAdjacentHTML('afterbegin', cc_items);
		this.$pm_contents[0].insertAdjacentHTML('afterbegin', pm_items);

		this.$cc_item = $('.cc-list__item');
		this.$cc_check_btn = $('.cc-item-check');

		this.$pm_item = $('.pm-item');
		this.$pm_product = $('.pm-item__product');
		this.$pm_check_btn = $('.pm-item-check');
		this.$pm_list = $('.pm-list');
		this.$pm_list_item = $('.pm-list__item');
		this.$rating_btn = $('.pm-item__product__rating-btn');
		this.$downloadFull_btn = $('.pm-item__product__fullpdf');
		this.addListeners();
		if (this.url_param['cas_number[]']) {
			this.$cc_check_btn.click();
		} else if (this.url_param['product_code[]']) {
			this.$pm_check_btn.click();
		}

		tm.to($('#loading'), 1, {
			css: {
				opacity: 0
			},
			onComplete: () => {
				$('#loading').remove();
				this.heightMatch();
				this.onResultResize();
			}
		});
	}

	/**
	 * CCとPMの高さ揃える
	 */
	heightMatch() {
		let cc_height = [];
		const min_h = mq.getLayout() === 'sp' ? 34 : 50;

		for (let i = 0, l = this.$cc_item.length; i < l; i++) {
			const ch = this.$cc_item.eq(i)[0].offsetHeight;

			if (ch > min_h) cc_height.push({
				index: i,
				height: ch
			});
		}

		for (let i = 0, l = this.$pm_list.length; i < l; i++) {
			const $pm_list = this.$pm_list.eq(i);

			for (let i = 0, l = cc_height.length; i < l; i++) {
				const current = cc_height[i];

				$pm_list[0].getElementsByClassName('pm-list__item')[current.index].style.height = `${current.height}px`;
			}
		}
	}

	/**
	 * CCチェック切り替え
	 */
	ccItemCheck(e) {
		const $_this = $(e.currentTarget);
		const index = this.$cc_check_btn.index($_this);
		const $cc_item = $_this.parent();
		const param = $cc_item.data();

		$cc_item.toggleClass('cc-list__item--checked');

		if ($cc_item.hasClass('cc-list__item--checked')) {
			this.set.cc.add(`${param.id}@*@${param.index}`);
			this.set.alias.add(`${param.alias}@*@${param.index}`);
		} else {
			this.set.cc.delete(`${param.id}@*@${param.index}`);
			this.set.alias.add(`${param.alias}@*@${param.index}`);
		}

		if (this.set.cc.size > 0) {
			this.$cc_clear_btn.addClass('result-btn__link--enable');
			this.$cc_only_btn.addClass('result-btn__link--enable');
		} else {
			this.is_cc_only = false;
			this.$cc_clear_btn.removeClass('result-btn__link--enable');
			this.$cc_only_btn.removeClass('result-btn__link--enable');
		}

		this.ccOnly();
		this.paramSet();

		// 該当製品行の色を変える
		for (let i = 0, l = this.$pm_list.length; i < l; i++) {
			this.$pm_list
				.eq(i)
				.find('.pm-list__item')
				.eq(index)
				.toggleClass('pm-list__item--checked');
		}
	}

	/**
	 * CCチェック全て削除
	 */
	ccAllClear(e) {
		const $_this = $(e.currentTarget);

		if (!$_this.hasClass('result-btn__link--enable')) return;

		this.$cc_item.removeClass('cc-list__item--checked');
		this.$pm_list.find('.pm-list__item').removeClass('pm-list__item--checked');
		$_this.removeClass('result-btn__link--enable');
		this.$cc_only_btn.removeClass('result-btn__link--enable');
		this.set.cc.clear();
		this.set.alias.clear();

		this.is_cc_only = false;

		this.ccOnly();
		this.paramSet();
	}

	/**
	 * CCチェック済みのみ表示切り替え
	 */
	ccToggleOnly(e) {
		const _this = $(e.currentTarget);

		if (!_this.hasClass('result-btn__link--enable')) return;

		this.is_cc_only = this.is_cc_only ? false : true;

		this.ccOnly();
	}

	/**
	 * CCチェック済みのみ表示
	 */
	ccOnly() {
		let cc_checked = [];
		let cc_index = [];
		let pm_checked = [];

		if (this.is_cc_only) {
			this.$cc_only_btn.find('.off_txt').hide();
			this.$cc_only_btn.find('.on_txt').show();

			for (let i = 0, l = this.$cc_item.length; i < l; i++) {
				const $current = this.$cc_item.eq(i);

				if ($current.hasClass('cc-list__item--checked')) {
					cc_checked.push($current[0]);
					cc_index.push(i);
				}
			}

			for (let i = 0, l = this.$pm_list.length; i < l; i++) {
				const $pm_list = this.$pm_list.eq(i);

				for (let i = 0, l = cc_index.length; i < l; i++) {
					pm_checked.push($pm_list.find('.pm-list__item').eq(cc_index[i])[0]);
				}
			}

			this.$cc_item.hide();
			$(cc_checked).show();

			this.$pm_list_item.hide();
			$(pm_checked).show();
		} else {
			this.$cc_only_btn.find('.off_txt').show();
			this.$cc_only_btn.find('.on_txt').hide();
			this.$cc_item.show();
			this.$pm_list_item.show();
		}
	}

	/**
	 * PMチェック切り替え
	 */
	pmItemCheck(e) {
		const $_this = $(e.currentTarget);
		const param = $_this.parents('.pm-item').data();

		$_this.toggleClass('pm-item-check--checked');

		if ($_this.hasClass('pm-item-check--checked')) {
			this.set.pm.add(`${param.id}@*@${param.index}`);
		} else {
			this.set.pm.delete(`${param.id}@*@${param.index}`);
		}

		if (this.set.pm.size > 0) {
			this.$pm_clear_btn.addClass('result-btn__link--enable');
			this.$pm_only_btn.addClass('result-btn__link--enable');
		} else {
			this.is_pm_only = false;
			this.$pm_clear_btn.removeClass('result-btn__link--enable');
			this.$pm_only_btn.removeClass('result-btn__link--enable');
		}

		this.pmOnly();
		this.paramSet();
	}

	/**
	 * PMチェック全て削除
	 */
	pmAllClear(e) {
		const $_this = $(e.currentTarget);

		if (!$_this.hasClass('result-btn__link--enable')) return;

		$_this.removeClass('result-btn__link--enable');
		this.$pm_check_btn.removeClass('pm-item-check--checked');
		this.$pm_only_btn.removeClass('result-btn__link--enable');
		this.set.pm.clear();

		this.is_pm_only = false;

		this.pmOnly();
		this.paramSet();
	}

	/**
	 * PMチェック済みのみ表示切り替え
	 */
	pmToggleOnly(e) {
		const _this = $(e.currentTarget);

		if (!_this.hasClass('result-btn__link--enable')) return;

		this.is_pm_only = this.is_pm_only ? false : true;
		this.pmOnly();
	}

	/**
	 * PMチェック済みのみ表示
	 */
	pmOnly() {
		let pm_checked = [];

		if (this.is_pm_only) {
			this.$pm_only_btn.find('.off_txt').hide();
			this.$pm_only_btn.find('.on_txt').show();

			for (let i = 0, l = this.$pm_item.length; i < l; i++) {
				const $current = this.$pm_item.eq(i);

				if ($current.find('.pm-item-check').hasClass('pm-item-check--checked')) {
					pm_checked.push($current[0]);
				}
			}

			this.$pm_item.hide();
			$(pm_checked).show();
		} else {
			this.$pm_only_btn.find('.off_txt').show();
			this.$pm_only_btn.find('.on_txt').hide();
			this.$pm_item.show();
		}
	}

	/**
	 * PM ratingのアコーディオン
	 */
	toggleRating(e) {
		const $_this = $(e.currentTarget);
		const index = this.$rating_btn.index($_this);

		if ($_this.hasClass('pm-item__product__rating-btn--no')) return;

		this.$pm_item.eq(index).toggleClass('pm-item--rating-open');
	}

	/**
	 * PDFページに渡すパラメータの設定
	 */
	paramSet() {
		this.param = {
			chemical_id: [],
			product_id: [],
			alias_no: []
		};

		if (this.set.cc.size > 0 && this.set.pm.size > 0) {
			for (let value of this.set.cc.values()) {
				const v = value.split('@*@');
				this.param.chemical_id.push({
					index: v[1],
					val: v[0]
				});
			}
			for (let value of this.set.alias.values()) {
				const v = value.split('@*@');
				this.param.alias_no.push({
					index: v[1],
					val: v[0]
				});
			}
			for (let value of this.set.pm.values()) {
				const v = value.split('@*@');
				this.param.product_id.push({
					index: v[1],
					val: v[0]
				});
			}

			this.$download_btn.removeClass('no-event');
		} else {
			this.$download_btn.addClass('no-event');
		}
	}

	/**
	 * トーストメッセージ非表示
	 */
	toastHide() {
		tm.killTweensOf(this.$toast);
		tm.to(this.$toast, 0.2, {
			css: {
				opacity: 0
			},
			ease: Power1.easeOut,
			onComplete: function () {
				this.target.removeClass('app-toast--show');
				tm.set(this.target, {
					clearProps: 'opacity'
				});
			}
		});
	}

	/**
	 * ダウンロードボタンクリック
	 */
	downloadClick(e) {
		const $_this = $(e.currentTarget);
		const form = document.createElement('form');
		const login = $('input[name="user_auth_cond"]').val();

		$('.sign-modal').hide();
		if (this.param.chemical_id.length > 130) {
			this.$toast.addClass('app-toast--show');
			clearTimeout(this.toast_timer);
			this.toast_timer = setTimeout($.proxy(this.toastHide, this), 2500);
			return false;
		}

		if ($_this.hasClass('no-event')) return false;

		form.action = this.$download_btn.attr('href');
		form.target = '_blank';
		form.method = 'post';
		form.acceptCharset = 'UTF-8';

		

		for (let i = 0, l = this.param.chemical_id.length; i < l; i++) {
			let chemical_id = document.createElement('input');
			chemical_id.type = 'hidden';
			chemical_id.name = `chemical_id[${this.param.chemical_id[i].index}]`;
			chemical_id.value = this.param.chemical_id[i].val;
			form.appendChild(chemical_id);
		}

		for (let i = 0, l = this.param.alias_no.length; i < l; i++) {
			let alias_no = document.createElement('input');
			alias_no.type = 'hidden';
			alias_no.name = `alias_no[${this.param.alias_no[i].index}]`;
			alias_no.value = this.param.alias_no[i].val;
			form.appendChild(alias_no);
		}

		for (let i = 0, l = this.param.product_id.length; i < l; i++) {
			let product_id = document.createElement('input');
			product_id.type = 'hidden';
			product_id.name = `product_id[${this.param.product_id[i].index}]`;
			product_id.value = this.param.product_id[i].val;
			form.appendChild(product_id);
		}


		// console.log('rootTypeId:'+this.rootTypeId);

		let type_id = document.createElement('input');
		type_id.type = 'hidden';
		type_id.name = `type`;
		type_id.value = this.rootTypeId;
		form.appendChild(type_id);

		if (location.host === 'chemrest.localhost' || location.host === 'chemrest.localhost:3000') {
			form.action = '../_develop/pdf.php';
		}
		// console.log(form);
		if (parseInt(login) === 1) {
			document.body.appendChild(form);
			form.submit();
		}

		return false;
	}

	onResultResize() {
		var pmW = this.$pm_contents.outerWidth(true) - 100;
		var num = this.$pm_item.outerWidth(true) * this.$pm_item.length;
		var itemLastLeft = this.$pm_item.offset().left;
		var itemLastW = this.$pm_item.outerWidth();
		var maxLeft = this.$pm_item.eq(this.$pm_item.length - 1).offset().left;
		if (pmW < num) {
			this.$btnArrow.show();
			this.pmArrowView();
		} else {
			this.$btnArrow.hide();
		}

		if ($('body').hasClass('lang-ja')) {
			this.$pm_detail = $('.pm-item__product__detail');
			this.$pm_detail.css({
				'height': 'auto'
			});

			let thH = 0;
			let ccH = 0;
			for (let i = 0; i < this.$pm_detail.length; i++) {
				let pmH = this.$pm_detail.eq(i).height();
				if (pmH > thH) {
					thH = pmH
				}

			}
			if (thH > 110 && mq.getLayout() != 'sp') {
				ccH = thH - 110;
				this.$pm_detail.height(thH);
				$('.result-btns--cc').css({
					'margin-top': ccH + 165 + 20 + 'px'
				});
			} else if (thH > 74 && mq.getLayout() === 'sp') {
				ccH = thH - 74;
				this.$pm_detail.height(thH);
				$('.result-btns--cc').css({
					'margin-top': ccH + 115 + 5 + 'px'
				});
			} else {
				this.$pm_detail.css({
					'height': ''
				});
			}
		}
	}

	pmArrow(e) {
		var _btn = e.currentTarget;
		var sl = this.$pm_contents.scrollLeft();
		var wNum = this.$pm_item.outerWidth(true);
		if ($(_btn).hasClass('left')) {
			wNum = wNum * -1;
		}
		this.$pm_contents.scrollLeft(sl + wNum);
		this.pmArrowView();
	}

	pmArrowView() {
		var sl = this.$pm_contents.scrollLeft();
		var num = this.$pm_item.outerWidth(true) * this.$pm_item.length;
		var flameNum = this.$pm_contents.outerWidth(true);
		var p = 100;
		this.$btnArrow.show();
		if (0 == sl) {
			$('.btn-result__arrow.left').hide();
		} else if (sl >= num - flameNum + p) {
			$('.btn-result__arrow.right').hide();
		}
		if (mq.getLayout() === 'sp') {
			this.$btnArrow.hide();
		}
	}
}

export default Result;



// WEBPACK FOOTER //
// ./src/js/app/Result.js